import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPercentage, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFFacturacionMunicipios from './PDFFacturacionMunicipios';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        filename: '',
        datosCargados: false,
        acuerdo_municipal: '',
        tipo_facturacion: '',
        id_tipo_facturacion: '',
        tarifa: '',
        consecutivo_fact: '',
        valor_tarifa: '',
        valor_factura: '',
        factura_munc: [],
        contribuyentes: [],
        departamentosMunc: [],
        municipiosMunc: [],
        periodos: [],
        comercializadores: [],
        datosFacturacion: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.factura_munc;
        state[e.target.name] = e.target.value;
        this.setState({ factura_munc: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const fecha_factura = document.getElementById('fecha_factura').value;
        const fecha_entrega = document.getElementById('fecha_entrega').value;
        const fecha_vencimiento = document.getElementById('fecha_vencimiento').value;
        const estado_factura = document.getElementById('ESTADO_FACTURA').value;
        const consecutivo_fact = document.getElementById('consecutivo_fact').value;
        const id_departamento = document.getElementById('ID_COD_DPTO').value;
        const id_municipio = document.getElementById('ID_COD_MPIO').value;
        const periodo_factura = document.getElementById('PERIODO_FACTURA').value;
        const id_contribuyente = document.getElementById('ID_CONTRIBUYENTE').value;
        const acuerdo_municipal = document.getElementById('acuerdo_municipal').value;
        const tipo_cliente = document.getElementById('ID_TIPO_CLIENTE').value;
        const liq_vencidas = document.getElementById('liq_vencidas').value;
        const valor_liq_vencidas = document.getElementById('valor_liq_vencidas').value;
        const tipo_facturacion = document.getElementById('tipo_facturacion').value;
        const tarifa = document.getElementById('tarifa').value;
        const valor_tarifa = document.getElementById('valor_tarifa').value;
        const valor_factura = document.getElementById('valor_factura').value;
        const id_comercializador = document.getElementById('ID_COMERCIALIZADOR').value;
        const facturado_por = document.getElementById('ID_FACTURADO_POR').value;
        var errores = [];
        if (!fecha_factura) { errores.push("error_fecha_factura"); }
        if (!fecha_entrega) { errores.push("error_fecha_entrega"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_factura) { errores.push("error_estado_factura"); }
        if (!consecutivo_fact) { errores.push("error_consecutivo_fact"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!periodo_factura) { errores.push("error_periodo_factura"); }
        if (!id_contribuyente) { errores.push("error_id_contribuyente"); }
        if (!acuerdo_municipal) { errores.push("error_acuerdo_municipal"); }
        if (!tipo_cliente) { errores.push("error_tipo_cliente"); }
        if (!liq_vencidas) { errores.push("error_liq_vencidas"); }
        if (!valor_liq_vencidas) { errores.push("error_valor_liq_vencidas"); }
        if (!tipo_facturacion) { errores.push("error_tipo_facturacion"); }
        if (!tarifa) { errores.push("error_tarifa"); }
        if (!valor_tarifa) { errores.push("error_valor_tarifa"); }
        if (!valor_factura) { errores.push("error_valor_factura"); }
        if (!id_comercializador) { errores.push("error_id_comercializador"); }
        if (!facturado_por) { errores.push("error_facturado_por"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("fact_municipio/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Facturación Municipio!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterFactMunicipio");
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('ID_COD_DPTO').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipiosMunc: datosRespuesta.data, load: '' });
                this.cargarContribuyentes();
                Swal.close();
            })
            .catch(console.log);
    }
    cargarContribuyentes() {
        Swal.showLoading();
        var id_departamento = document.getElementById("ID_COD_DPTO").value;
        var id_municipio = document.getElementById("ID_COD_MPIO").value;
        console.log(id_departamento + " - " + id_municipio);
        authAxios.get("contribuyentes/contribuyente_munc/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, contribuyentes: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    cargarInfoContribuyente() {
        Swal.showLoading();
        var id_contribuyente = document.getElementById("ID_CONTRIBUYENTE").value;
        var ano_fact = document.getElementById("PERIODO_FACTURA").value.substr(0, 4);
        document.getElementById('valor_tarifa').value = "";
        document.getElementById('valor_factura').value = "";
        authAxios.get("contribuyentes/contribuyente_info/" + id_contribuyente + "/" + ano_fact)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var consecutivo_fact
                this.setState({ datosCargados: true, load: '' });
                if (id_contribuyente.length === 1) {
                    consecutivo_fact = "0" + datosRespuesta.data.resultado.ID_CONTRIBUYENTE + "" +
                                               document.getElementById("PERIODO_FACTURA").value.substr(4, 2) + "" +
                                               document.getElementById("PERIODO_FACTURA").value.substr(0, 4) + "-" +
                                               datosRespuesta.data.resultado_fact_espc;
                } else {
                    consecutivo_fact = datosRespuesta.data.resultado.ID_CONTRIBUYENTE + "" +
                                               document.getElementById("PERIODO_FACTURA").value.substr(4, 2) + "" +
                                               document.getElementById("PERIODO_FACTURA").value.substr(0, 4) + "-" +
                                               datosRespuesta.data.resultado_fact_espc;
                }
                document.getElementById("consecutivo_fact").value = consecutivo_fact;
                this.setState({ id_tipo_facturacion: datosRespuesta.data.resultado.ID_TIPO_FACTURACION,
                                acuerdo_municipal: datosRespuesta.data.resultado.ACUERDO_MCPAL,
                                tarifa: datosRespuesta.data.resultado.TARIFA,
                                consecutivo_fact: consecutivo_fact });
                switch (datosRespuesta.data.resultado.ID_TIPO_FACTURACION) {
                    case 1:
                        document.getElementById("tipo_facturacion").value = "CONSUMO";
                        this.setState({ tipo_facturacion: "CONSUMO", valor_tarifa: '', valor_factura: '' });
                        break;
                    case 2:
                        document.getElementById("tipo_facturacion").value = "SALARIOS";
                        this.setState({ tipo_facturacion: "SALARIOS",
                                        valor_factura: (datosRespuesta.data.resultado.TARIFA * datosRespuesta.data.resultado_smlv.SALARIO_MINIMO),
                                        valor_tarifa: datosRespuesta.data.resultado_smlv.SALARIO_MINIMO });
                        break;
                    case 3:
                        document.getElementById("tipo_facturacion").value = "UVT";
                        this.setState({ tipo_facturacion: "UVT",
                                        valor_factura: (datosRespuesta.data.resultado.TARIFA * datosRespuesta.data.resultado_uvt.UVT),
                                        valor_tarifa: datosRespuesta.data.resultado_uvt.UVT });
                        break;
                    case 4:
                        document.getElementById("tipo_facturacion").value = "COMCERCIAL";
                        this.setState({ tipo_facturacion: "COMERCIAL", valor_tarifa: '', valor_factura: '' });
                        break;
                }
                Swal.close();
            })
            .catch(console.log);
    }
    calcularValorTarifa = () => {
        var tarifa = document.getElementById("tarifa").value;
        var valor_tarifa = document.getElementById("valor_tarifa").value;
        this.setState({ valor_factura: (Math.round((tarifa / 100) * valor_tarifa)) });
        document.getElementById('valor_factura').value = (Math.round((tarifa / 100) * valor_tarifa));
    }
    crearConsecutivoFact = () => {
        var id_contribuyente = document.getElementById("ID_CONTRIBUYENTE").value;
        var consecutivo_fact = document.getElementById("consecutivo_fact").value;
        if (id_contribuyente.length === 1) {
            consecutivo_fact = "0" + id_contribuyente + "" +
                                     document.getElementById("PERIODO_FACTURA").value.substr(4, 2) + "" +
                                     document.getElementById("PERIODO_FACTURA").value.substr(0, 4) + "-" +
                                     consecutivo_fact.split('-')[1];
        } else {
            consecutivo_fact = id_contribuyente + "" +
                                       document.getElementById("PERIODO_FACTURA").value.substr(4, 2) + "" +
                                       document.getElementById("PERIODO_FACTURA").value.substr(0, 4) + "-" +
                                       consecutivo_fact.split('-')[1];
        }
        document.getElementById("consecutivo_fact").value = consecutivo_fact;
        this.setState({ consecutivo_fact: consecutivo_fact });
    }
    previewPDFFacturacionMunicipios = (id_fact) => {
        authAxios.get(`fact_municipio/generar_factura/${id_fact}`)
            .then((response) => {
                let status = response.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                let filename = `AGM - Factura Cliente Especial_${response.data.resultEspecial[0].NOMBRE} - ${response.data.resultEspecial[0].PERIODO_FACTURA}.pdf`
                this.setState({ datosFacturacion: response.data.resultEspecial, filename:  filename});
            })
    }
    cleanData = () => {
        this.setState({ datosFacturacion: [], filename: '' });
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("fact_municipio/periodos_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, periodos: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("comercializadores/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, comercializadores: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("fact_municipio/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true,
                                factura_munc: datosRespuesta.data.resultado,
                                acuerdo_municipal: datosRespuesta.data.resultado.ACUERDO_MCPAL,
                                id_tipo_facturacion: datosRespuesta.data.resultado.ID_TIPO_FACTURACION,
                                tarifa: datosRespuesta.data.resultado.TARIFA,
                                consecutivo_fact: datosRespuesta.data.resultado.CONSECUTIVO_FACT,
                                valor_tarifa: datosRespuesta.data.resultado.VALOR_TARIFA,
                                valor_factura: datosRespuesta.data.resultado.VALOR_FACTURA,
                                load: '' });
                switch (datosRespuesta.data.resultado.ID_TIPO_FACTURACION) {
                    case 1:
                        document.getElementById("tipo_facturacion").value = "CONSUMO";
                        this.setState({ tipo_facturacion: "CONSUMO" });
                        break;
                    case 2:
                        document.getElementById("tipo_facturacion").value = "SALARIOS";
                        this.setState({ tipo_facturacion: "SALARIOS" });
                        break;
                    case 3:
                        document.getElementById("tipo_facturacion").value = "UVT";
                        this.setState({ tipo_facturacion: "UVT" });
                        break;
                    case 4:
                        document.getElementById("tipo_facturacion").value = "COMCERCIAL";
                        this.setState({ tipo_facturacion: "COMERCIAL" });
                        break;
                }
                var id_departamento = datosRespuesta.data.resultado.ID_COD_DPTO;
                var id_municipio = datosRespuesta.data.resultado.ID_COD_MPIO;
                document.getElementById("ID_COD_DPTO").value = id_departamento;
                document.getElementById("ID_COD_MPIO").value = id_municipio;
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosMunc: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
    }

    render() {
        const { load, tipo_facturacion, id_tipo_facturacion, acuerdo_municipal,
                tarifa, consecutivo_fact, valor_tarifa, valor_factura,
                factura_munc, periodos, contribuyentes, comercializadores,
                departamentosMunc, municipiosMunc, datosFacturacion, filename
            } = this.state;
        return (
            <>
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    {load ? (<b>{load}</b>) : (<b>EDITAR FACTURA MUNICIPIO</b>)}
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.enviarDatos} id="form">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className='row g-3'>
                                                    <div className="col-md-2">
                                                        <input type="hidden" name="id_facturacion" value={this.props.match.params.id} />
                                                        <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                        <label htmlFor="fecha_factura">Fecha Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" defaultValue={factura_munc.FECHA_FACTURA}
                                                                className={((this.verificarError("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Factura" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="fecha_entrega">Fecha Entrega</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_entrega" id="fecha_entrega" defaultValue={factura_munc.FECHA_ENTREGA}
                                                                className={((this.verificarError("error_fecha_entrega")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Entrega" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" defaultValue={factura_munc.FECHA_VENCIMIENTO}
                                                                className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Vencimiento" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Vencimiento</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="PERIODO_FACTURA">Periodo Factura</label>
                                                        <select name="PERIODO_FACTURA"
                                                            id="PERIODO_FACTURA"
                                                            value={factura_munc.PERIODO_FACTURA}
                                                            options={factura_munc.PERIODO_FACTURA}
                                                            onChange={(e) => {
                                                                this.cambioValor(e);
                                                                this.crearConsecutivoFact(e);
                                                            }}
                                                            className={((this.verificarError("error_periodo_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                            <option value="">Seleccione el Periodo Factura</option>
                                                            {
                                                                periodos.map((itemPeriodos) => (
                                                                    <option key={itemPeriodos.ID_TABLA} value={itemPeriodos.ANO_FACTURA + "" + itemPeriodos.MES_FACTURA}>{itemPeriodos.PERIODO} - {itemPeriodos.ANO_FACTURA}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Periodo Factura</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ESTADO_FACTURA">Estado Factura</label>
                                                        <select name="ESTADO_FACTURA"
                                                            id="ESTADO_FACTURA"
                                                            value={factura_munc.ESTADO_FACTURA}
                                                            options={factura_munc.ESTADO_FACTURA}
                                                            className={((this.verificarError("error_estado_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                                <option value="">Seleccione el Estado Factura</option>
                                                                <option value="1">ENTREGADO</option>
                                                                <option value="2">PENDIENTE DE ENVÍO</option>
                                                                <option value="3">RECLAMADA</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Estado Factura</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN MUNICIPIO / CONTRIBUYENTE</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                        <select name="ID_COD_DPTO"
                                                            id="ID_COD_DPTO"
                                                            value={factura_munc.ID_COD_DPTO}
                                                            options={factura_munc.ID_COD_DPTO}
                                                            onChange={e => {
                                                                this.cargarMunicipios(e);
                                                                this.cambioValor(e)
                                                            }}
                                                            className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                            <option value="">Seleccione el Departamento</option>
                                                            {
                                                                departamentosMunc.map((itemDepartamentosComer) => (
                                                                    <option key={itemDepartamentosComer.ID_TABLA} value={itemDepartamentosComer.ID_DEPARTAMENTO}>{itemDepartamentosComer.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                        <select name="ID_COD_MPIO"
                                                            id="ID_COD_MPIO"
                                                            value={factura_munc.ID_COD_MPIO}
                                                            options={factura_munc.ID_COD_MPIO}
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={(e) => {
                                                                this.cargarContribuyentes(e);
                                                                this.cambioValor(e)
                                                            }}>
                                                            <option value="">Seleccione el Municipio</option>
                                                            {
                                                                municipiosMunc.map((itemMunicipiosMunc) => (
                                                                    <option key={itemMunicipiosMunc.ID_TABLA} value={itemMunicipiosMunc.ID_MUNICIPIO}>{itemMunicipiosMunc.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor="ID_CONTRIBUYENTE">Contribuyente</label>
                                                        <select name="ID_CONTRIBUYENTE"
                                                            id="ID_CONTRIBUYENTE"
                                                            value={factura_munc.ID_CONTRIBUYENTE}
                                                            options={factura_munc.ID_CONTRIBUYENTE}
                                                            className={((this.verificarError("error_id_contribuyente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={(e) => {
                                                                this.cargarInfoContribuyente(e);
                                                                this.cambioValor(e)
                                                            }}>
                                                            <option value="">Seleccione el Contribuyente</option>
                                                            {
                                                                contribuyentes.map((itemContribuyentes) => (
                                                                    <option key={itemContribuyentes.ID_CONTRIBUYENTE} value={itemContribuyentes.ID_CONTRIBUYENTE}>{itemContribuyentes.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Contribuyente</small>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-6">
                                                        <label htmlFor="acuerdo_municipal">Acuerdo Municipal</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="acuerdo_municipal" id="acuerdo_municipal" defaultValue={acuerdo_municipal}
                                                            className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ACUERDO MUNICIPAL" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                        <small id="helpId" className="invalid-feedback">Digite el Acuerdo Municipal</small>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <label htmlFor="ID_TIPO_CLIENTE">Tipo Cliente</label>
                                                        <select name="ID_TIPO_CLIENTE"
                                                            id="ID_TIPO_CLIENTE"
                                                            value={factura_munc.ID_TIPO_CLIENTE}
                                                            options={factura_munc.ID_TIPO_CLIENTE}
                                                            className={((this.verificarError("error_tipo_cliente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                            <option value="">Seleccione el Tipo Cliente</option>
                                                            <option value="1">ANTIGUO</option>
                                                            <option value="2">NUEVO</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Tipo Cliente</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN VALORES / USUARIOS</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-2">
                                                        <label htmlFor="consecutivo_fact">Consecutivo Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="consecutivo_fact" id="consecutivo_fact" defaultValue={consecutivo_fact}
                                                                className={((this.verificarError("error_consecutivo_fact")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Consecutivo Fact." aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Consecutivo Factura</small>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-2">
                                                        <label htmlFor="liq_vencidas">Liq. Vencidas</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="liq_vencidas" id="liq_vencidas" defaultValue={factura_munc.NO_LIQ_VENCIDAS}
                                                                className={((this.verificarError("error_liq_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Liq. Vencidas" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite las Liq. Vencidas</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_liq_vencidas">Valor Liq. Vencidas</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_liq_vencidas" id="valor_liq_vencidas" defaultValue={factura_munc.VALOR_LIQ_VENCIDAS}
                                                                className={((this.verificarError("error_valor_liq_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Liq. Vencidas" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Liq. Vencidas</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="tipo_facturacion">Tipo Facturación</label>
                                                        <input type="hidden" name='id_tipo_facturacion' id='id_tipo_facturacion' defaultValue={id_tipo_facturacion} />
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tipo_facturacion" id="tipo_facturacion" defaultValue={tipo_facturacion}
                                                            className={((this.verificarError("error_tipo_facturacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="TIPO FACTURACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                        <small id="helpId" className="invalid-feedback">Digite el Tipo Facturación</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="tarifa">Tarifa</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={id_tipo_facturacion === 1 ? faPercentage : faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="tarifa" id="tarifa" defaultValue={tarifa}
                                                                className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa" aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_tarifa">Valor Tarifa</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_tarifa" id="valor_tarifa" defaultValue={valor_tarifa}
                                                                className={((this.verificarError("error_valor_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Tarifa" aria-describedby="helpId"
                                                                onChange={(e) => {
                                                                    this.cambioValor(e);
                                                                    this.calcularValorTarifa(e);
                                                                }}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Tarifa</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_factura">Valor Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_factura" id="valor_factura" defaultValue={valor_factura}
                                                                className={((this.verificarError("error_valor_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Factura" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Factura</small>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor="ID_COMERCIALIZADOR">Comercializadora</label>
                                                        <select name="ID_COMERCIALIZADOR"
                                                            id="ID_COMERCIALIZADOR"
                                                            value={factura_munc.ID_COMERCIALIZADOR}
                                                            options={factura_munc.ID_COMERCIALIZADOR}
                                                            className={((this.verificarError("error_id_comercializador")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                            <option value="">Seleccione la Comercializadora</option>
                                                            {
                                                                comercializadores.map((itemComercializadores) => (
                                                                    <option key={itemComercializadores.ID_COMERCIALIZADOR} value={itemComercializadores.ID_COMERCIALIZADOR}>{itemComercializadores.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Comercializadora</small>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <label htmlFor="ID_FACTURADO_POR">Facturado Por</label>
                                                        <select name="ID_FACTURADO_POR"
                                                            id="ID_FACTURADO_POR"
                                                            value={factura_munc.ID_FACTURADO_POR}
                                                            options={factura_munc.ID_FACTURADO_POR}
                                                            className={((this.verificarError("error_tipo_cliente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                            <option value="">Seleccione Facturado Por</option>
                                                            <option value="1">COMERCIALIZADOR</option>
                                                            <option value="2">CUENTA DE COBRO</option>
                                                            <option value="3">RESOLUCIÓN</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione Facturado Por</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row'>
                                            <div className='col-xl-12 text-center'>
                                                <div className="btn-group" role="group" aria-label="">
                                                    <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Fact. Municipio</button>&nbsp;&nbsp;
                                                    <Link className="btn btn-danger btn-sm" to={"/MasterFactMunicipio"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>&nbsp;&nbsp;
                                                    <button type="button" className="btn btn-secondary btn-sm" data-bs-toggle='modal' data-bs-target="#PDFFacturacionMunicipiosModal" slot='end'
                                                        onClick={() => {
                                                            this.previewPDFFacturacionMunicipios(this.props.match.params.id)
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Imprimir Factura
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFFacturacionMunicipiosModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ActaInterventoriaoLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Facturación Aportes Municipales</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFFacturacionMunicipios data={datosFacturacion} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Descargar PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" onClick={this.cleanData} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12 mb-3'>

                                        {
                                            datosFacturacion[0] ?
                                                (
                                                    <div>
                                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                                            <PDFFacturacionMunicipios data={datosFacturacion} />
                                                        </PDFViewer>
                                                    </div>

                                                ) : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Editar;